"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const api_1 = require("../../api");
const NewColumnToolPanelComponent = (props) => {
    const [name, setName] = (0, react_1.useState)('');
    const [type, setType] = (0, react_1.useState)('string');
    const [selectedView, setSelectedView] = (0, react_1.useState)('');
    const gridApi = props.api;
    const columnApi = props.columnApi;
    const viewsApi = new api_1.ViewsApi;
    const columnTypes = [
        { type: 'date', name: 'Date' },
        { type: 'string', name: 'Text' },
        { type: 'boolean', name: 'True/False' },
    ];
    const create = async () => {
        const payload = {
            name,
            type,
        };
        const response = await viewsApi.create(payload);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "ag-wrapper ag-input-wrapper ag-text-field-input-wrapper", role: "presentation" },
            react_1.default.createElement("input", { value: name, onChange: (event => setName(event.target.value)), className: "ag-input-field-input ag-text-field-input", type: "text", id: "ag-20-input", "aria-label": "Filter Columns TextInput", placeholder: "name" })),
        "Views",
        react_1.default.createElement("select", { name: "views", id: "", value: type, onChange: event => setType(event.target.value) },
            react_1.default.createElement("option", { value: '' }),
            columnTypes.map((type) => react_1.default.createElement("option", { key: type.type, value: type.type }, type.name))),
        react_1.default.createElement("button", { onClick: () => { create(); } }, "Create")));
};
exports.default = NewColumnToolPanelComponent;
